var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-p-3"
  }, [_c('b-modal', {
    attrs: {
      "id": "modal-detail",
      "centered": "",
      "hide-header": "",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var close = _ref.close;
        return [_vm.currentTask ? _c('div', {
          staticClass: "p-2 badge__detail",
          style: _vm.colorObject
        }, [_c('button', {
          staticClass: "badge__detail__close",
          on: {
            "click": function click($event) {
              return close();
            }
          }
        }, [_c('img', {
          attrs: {
            "src": require("./images/close.svg")
          }
        })]), _c('div', {
          staticClass: "badge__detail__hero p-4",
          class: _vm.currentTask.progress == 100 && 'active'
        }, [_c('div', {
          staticClass: "badge__detail__hero__img w-50 m-auto"
        }, [_c('img', {
          attrs: {
            "src": _vm.currentTask.image_url || require("./images/question.svg")
          }
        })]), _c('div', {
          staticClass: "badge__detail__hero__title mt-2"
        }, [_vm._v(" " + _vm._s(_vm.currentTask.name) + " ")])]), _c('div', {
          staticClass: "py-3 border-bottom"
        }, [_c('div', {
          staticClass: "font-weight-bold h6"
        }, [_vm._v("任務")]), _c('div', [_vm._v(_vm._s(_vm.currentTask.description))]), _c('div', {
          staticClass: "badge__task__progress my-2"
        }, [_c('div', {
          staticClass: "badge__task__progress__bar",
          style: {
            width: "".concat(_vm.currentTask.progress, "%")
          }
        })]), _c('div', {
          staticClass: "text-right s-primary"
        }, [_vm._v(_vm._s(_vm.currentTask.progress) + "%")])]), _c('div', {
          staticClass: "py-3"
        }, [_c('div', {
          staticClass: "font-weight-bold h6"
        }, [_vm._v("注意事項")]), _c('div', [_vm._v(_vm._s(_vm.currentTask.description))])]), _c('SharedButton', [_vm._v("前往綁定")])], 1) : _vm._e()];
      }
    }])
  }), _vm._l(_vm.events, function (i) {
    return _c('b-card', {
      key: i.id,
      staticClass: "badge w-100 mb-2 text-wrap",
      attrs: {
        "no-body": ""
      }
    }, [_c('div', {
      staticClass: "badge__hero",
      style: {
        background: i.bg
      }
    }, [_c('img', {
      staticClass: "img-fluid badge__hero_img",
      attrs: {
        "src": i.img_url
      }
    }), _c('div', {
      staticClass: "px-4 py-3"
    }, [_c('div', {
      staticClass: "badge__progress"
    }, [_c('div', {
      staticClass: "badge__progress__bar",
      style: {
        width: "".concat(i.progress, "%")
      }
    })]), _c('div', {
      staticClass: "text-white mt-1 text-left"
    }, [_vm._v("已達成 " + _vm._s(i.progress) + " %")])])]), _c('div', {
      staticClass: "px-3 pb-3"
    }, [_vm.isEventDetail ? _c('div', {
      staticClass: "row py-3 border-bottom m-0"
    }, _vm._l(i.badges, function (t, idx) {
      return _c('b-col', {
        key: idx,
        staticClass: "p-2",
        attrs: {
          "cols": "3"
        }
      }, [_c('button', {
        directives: [{
          name: "b-modal",
          rawName: "v-b-modal.modal-detail",
          modifiers: {
            "modal-detail": true
          }
        }],
        staticClass: "badge__task",
        class: t.progress == 100 && 'active',
        on: {
          "click": function click($event) {
            return _vm.goToBadgeDetail(i.id, t.id);
          }
        }
      }, [_c('img', {
        attrs: {
          "src": t.image_url || require("./images/question.svg")
        }
      })]), _c('div', {
        staticClass: "badge__task__progress my-2",
        class: t.progress == 100 && 'invisible'
      }, [_c('div', {
        staticClass: "badge__task__progress__bar",
        style: {
          width: "".concat(t.progress, "%")
        }
      })]), _c('div', {
        staticClass: "badge__task__name"
      }, [_vm._v(_vm._s(t.name))])]);
    }), 1) : _vm._e(), _c('hr'), _c('div', {
      staticClass: "pt-3"
    }, [_c('div', {
      staticClass: "d-flex justify-content-between align-items-center"
    }, [_c('span', {
      staticClass: "badge__date"
    }, [i.more ? _c('span', [_vm._v("任務日期：")]) : _vm._e(), _vm._v(" " + _vm._s(i.start_at ? _vm.moment(i.start_at).format('YYYY-MM-DD') : "即日起") + " ~ " + _vm._s(_vm.moment(i.end_at).format('YYYY-MM-DD')))]), !i.more ? _c('SharedButton', {
      staticClass: "s-btn-outline-primary w-auto py-2",
      on: {
        "click": function click($event) {
          return _vm.goToEventDetail(i.id);
        }
      }
    }, [_vm._v("MORE")]) : _vm._e()], 1), _vm.isEventDetail ? _c('div', {
      staticClass: "badge__description mt-2"
    }, [_vm._v(" " + _vm._s(i.description) + " ")]) : _vm._e()])])]);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }